import { URL } from '../../config'
import { getRequest, postRequest } from '../../utils/functions/httpRequest'
import { types } from './'

const postEventURL = URL.postevent
const memberURL = URL.member
const seasonURL = URL.season

export function optOutAdvancer(id) {
  return (dispatch, getState) => {
    const url = `${postEventURL}/${id}/optout`
    const userToken = getState().oidc.user.access_token
    postRequest(url, null, userToken).then(resp => {
      dispatch(optOutAdvancerSuccess(resp.data))
    })
  }
}

export function optOutAdvancerSuccess(data) {
  return {
    type: types.PostEvent.OPT_OUT,
    payload: data
  }
}

export function fetchPostEventSuccess(event) {
  return {
    type: types.PostEvent.FETCH_POST_EVENT,
    payload: event
  }
}

export function fetchingPostEvent() {
  return {
    type: types.PostEvent.FETCHING_POST_EVENT
  }
}

export function fetchPostEvent(eventId) {
  return (dispatch, getState) => {
    const userToken = getState().oidc.user.access_token
    const url = `${postEventURL}/${eventId}/postevent`
    dispatch(fetchingPostEvent())
    getRequest(url, 'json', userToken).then(resp => {
      dispatch(fetchPostEventSuccess(resp))
    })
  }
}

export function resetWizardState(currentStep) {
  return {
    type: types.PostEvent.RESET_WIZARD_STATE,
    payload: currentStep,
  }
}

export function resetPostEventWizard() {
  return {
    type: types.PostEvent.RESET_POST_EVENT_WIZARD
  }
}

export function uploadingResultsFile() {
  return {
    type: types.PostEvent.UPLOADING_RESULTS_FILE
  };
}

export function uploadResultsFile(results) {
  return (dispatch, getState) => {
    const id = results.get('eventId');
    const url = `${postEventURL}/${id}/uploadresults`
    const userToken = getState().oidc.user.access_token
    postRequest(url, results, userToken).then(resp => {
      dispatch(uploadResultsSuccess(resp.data));
    })
  }
}

export function uploadResultsSuccess(results) {
  return {
    type: types.PostEvent.UPLOAD_RESULTS_FILE,
    payload: results,
  };
}

export function prestineNavigateNext() {
  return {
    type: types.PostEvent.PRESTINE_NAVIGATE_NEXT,
  }
}

export function setSearchMode(searchMode) {
  return (dispatch) => {
    dispatch(setSearchModeSuccess(searchMode))
  }
}

export function setSearchModeSuccess(searchMode) {
  return {
    type: types.PostEvent.SET_SEARCH_MODE,
    payload: searchMode,
  }
}

export function fetchMember(prefix, suffix) {
  return (dispatch, getState) => {
    const url = `${memberURL}/juniorgold/${prefix}/${suffix}`
    const userToken = getState().oidc.user.access_token
    getRequest(url, 'json', userToken).then(resp => {
      dispatch(fetchMemberSuccess(resp.data))
    })
  }
}

export function fetchMemberSuccess(member) {
  return {
    type: types.PostEvent.FETCH_MEMBER,
    payload: member
  }
}

export function savingAthlete() {
  return {
    type: types.PostEvent.SAVING_ATHLETE,
  }
}

export function saveAdvancerSuccess(results) {
  return {
    type: types.PostEvent.SAVE_ADVANCER,
    payload: results,
  };
}

export function saveAlternateSuccess(results) {
  return {
    type: types.PostEvent.SAVE_ALTERNATE,
    payload: results,
  };
}

export function saveAdvancer(eventId, divisionId, advancer, divisionHeldId) {
  return (dispatch, getState) => {
    const url = `${postEventURL}/${eventId}/${divisionId}/${divisionHeldId}/advancer`
    const userToken = getState().oidc.user.access_token
    postRequest(url, advancer, userToken).then(resp => {
      dispatch(saveAdvancerSuccess(resp.data));
    })
  }
}

export function saveAlternate(eventId, divisionId, alternate, divisionHeldId) {
  return (dispatch, getState) => {
    const url = `${postEventURL}/${eventId}/${divisionId}/${divisionHeldId}/alternate`
    const userToken = getState().oidc.user.access_token
    postRequest(url, alternate, userToken).then(resp => {
      dispatch(saveAlternateSuccess(resp.data));
    })
  }
}

export function deleteAdvancer(advancerId, eventId, divisionId) {
  return (dispatch, getState) => {
    const url = `${postEventURL}/${advancerId}/${eventId}/${divisionId}/deleteadvancer`
    const userToken = getState().oidc.user.access_token
    postRequest(url, null, userToken).then(resp => {
      dispatch(deleteAdvancerSuccess(resp.data))
    })
  }
}
export function resendAdvancerEmail(eventId, advancer) {
  return (dispatch, getState) => {
    const url = `${postEventURL}/${eventId}/resendadvanceremail`
    const userToken = getState().oidc.user.access_token
    postRequest(url, advancer, userToken).then(resp => {
      dispatch(resendAdvancerEmailSuccess(resp.data))
    })
  }
}


export function updateAdvancer(advancerId, advancer) {
  return (dispatch, getState) => {
    const url = `${postEventURL}/${advancerId}/updateadvancer`
    const userToken = getState().oidc.user.access_token
    postRequest(url, advancer, userToken).then(resp => {
      dispatch(updateAdvancerSuccess(resp.data))
    })
  }
}

export function updateAdvancerSuccess(resp) {
  return {
    type: types.PostEvent.UPDATE_ADVANCER,
    payload: resp,
  }
}
export function updateAlternate(alternateId, alternate) {
  return (dispatch, getState) => {
    const url = `${postEventURL}/${alternateId}/updatealternate`
    const userToken = getState().oidc.user.access_token
    postRequest(url, alternate, userToken).then(resp => {
      dispatch(updateAlternateSuccess(resp.data))
    })
  }
}

export function updateAlternateSuccess(resp) {
  return {
    type: types.PostEvent.UPDATE_ALTERNATE,
    payload: resp,
  }
}
export function updateAlternatesOrder(alternates) {
  return (dispatch, getState) => {
    const url = `${postEventURL}/updatealternatesorder`
    const userToken = getState().oidc.user.access_token
    postRequest(url, alternates, userToken).then(resp => {
      dispatch(updateAlternatesOrderSuccess(resp.data))
    })
  }
}

export function updateAlternatesOrderSuccess(resp) {
  return {
    type: types.PostEvent.UPDATE_ALTERNATES_ORDER,
    payload: resp,
  }
}
export function resendAdvancerEmailSuccess(resp) {
  return {
    type: types.PostEvent.RESEND_ADVANCER_EMAIL,
    payload: resp,
  }
}
export function deleteAdvancerSuccess(resp) {
  return {
    type: types.PostEvent.DELETE_ADVANCER,
    payload: resp,
  }
}

export function deleteAlternate(alternateId, eventId, divisionId) {
  return (dispatch, getState) => {
    const url = `${postEventURL}/${alternateId}/${eventId}/${divisionId}/deletealternate`
    const userToken = getState().oidc.user.access_token
    postRequest(url, null, userToken).then(resp => {
      dispatch(deleteAlternateSuccess(resp.data))
    })
  }
}

export function deleteAlternateSuccess(resp) {
  return {
    type: types.PostEvent.DELETE_ALTERNATE,
    payload: resp,
  }
}

export function savePayment(id, amount) {
  return (dispatch, getState) => {
    dispatch(savingFeePayment());

    const url = `${postEventURL}/${id}/payment`
    const userToken = getState().oidc.user.access_token
    postRequest(url, amount, userToken).then(resp => {
      dispatch(savePaymentSuccess(resp.data));
    })
      .catch(function (err) {
        let status;
        let data;

        if (err.response !== undefined) {
          status = err.response.status;
          data = err.response.data;
        }
        else {
          status = 400;
          data = {
            ApplicationError: [err.Error]
          }
        }
        const response = {
          status,
          data,
        }
        dispatch(savePaymentFailure(response));
      });
  }
}

export function savePaymentFailure(errorInfo) {
  return {
    type: types.PostEvent.SAVE_FEE_PAYMENT_ERROR,
    payload: errorInfo
  }
}

export function savePaymentSuccess(amount) {
  return {
    type: types.PostEvent.SAVE_FEE_PAYMENT,
    payload: amount,
  };
}

export function savingFeePayment() {
  return {
    type: types.PostEvent.SAVING_FEE_PAYMENT,
  };
}

export function addMixedAgeDivision() {
  return {
    type: types.PostEvent.ADD_MIXED_AGE_DIVISION,
  }
}

export function completedEvent(eventId) {
  return (dispatch, getState) => {
    const url = `${postEventURL}/${eventId}/completedevent`
    const userToken = getState().oidc.user.access_token
    postRequest(url, eventId, userToken).then(resp => {
      dispatch(completedEventSuccess(resp.data));
    })
      .catch(function (err) {
        let status;
        let data;

        if (err.response !== undefined) {
          status = err.response.status;
          data = err.response.data;
        } else {
          status = 400;
          data = {
            ApplicationError: [err.Error]
          }
        }
        const response = {
          status,
          data,
        }
        dispatch(completedEventFailure(response));
      });
  }
}

export function completedEventSuccess(eventId) {
  return {
    type: types.PostEvent.COMPLETE_EVENT,
    payload: eventId,
  }
}

export function completedEventFailure(errorInfo) {
  return {
    type: types.PostEvent.COMPLETE_EVENT_ERROR,
    payload: errorInfo,
  }
}

export function fetchActiveSeasons() {
  const url = `${seasonURL}/active`
  const request = getRequest(url)
  return {
    type: types.Season.FETCH_ACTIVE_SEASONS,
    payload: request
  }
}

export function savePostEventSetup(id, setup) {
  return (dispatch, getState) => {
    const url = `${postEventURL}/${id}/setup`
    const userToken = getState().oidc.user.access_token
    postRequest(url, setup, userToken).then(resp => {
      dispatch(savePostEventSetupSuccess(resp.data));
    })
      .catch(function (err) {
        let status;
        let data;

        if (err.response !== undefined) {
          status = err.response.status;
          data = err.response.data;
        }
        else {
          status = 400;
          data = {
            ApplicationError: [err.Error]
          }
        }
        const response = {
          status,
          data,
        }
        dispatch(savePostEventSetupFailure(response));
      });
  }
}

export function savePostEventSetupSuccess(setup) {
  return {
    type: types.PostEvent.SAVE_POST_EVENT_SETUP,
    payload: setup,
  };
}

export function savePostEventSetupFailure(errorInfo) {
  return {
    type: types.PostEvent.SAVE_POST_EVENT_SETUP_ERROR,
    payload: errorInfo
  }
}

export function deleteEventDivisionHeld(eventId, id) {
  return (dispatch, getState) => {
    const url = `${postEventURL}/${eventId}/${id}/deletedivisionheld`
    const userToken = getState().oidc.user.access_token
    postRequest(url, null, userToken).then(resp => {
      dispatch(deleteEventDivisionHeldSuccess(resp.data))
    })
  }
}

export function deleteEventDivisionHeldSuccess(resp) {
  return {
    type: types.PostEvent.DELETE_EVENT_DIVISION_HELD,
    payload: resp,
  };
}

export function savePostEventAdvancersError(errors) {
  return {
    type: types.PostEvent.SAVE_POST_EVENT_ADVANCERS_ERROR,
    payload: errors,
  };
}

export function savePostEventAdvancersSuccess(resp) {
  return {
    type: types.PostEvent.SAVE_POST_EVENT_ADVANCERS,
    payload: resp
  };
}

export function savePostEventAdvancers(id, mixedAgeDivisionsHeld) {
  return (dispatch, getState) => {
    const url = `${postEventURL}/${id}/recordadvancers`
    const userToken = getState().oidc.user.access_token
    postRequest(url, mixedAgeDivisionsHeld, userToken).then(resp => {
      dispatch(savePostEventAdvancersSuccess(resp));
    })
      .catch(function (err) {
        let status;
        let data;

        if (err.response !== undefined) {
          status = err.response.status;
          data = err.response.data;
        }
        else {
          status = 400;
          data = {
            ApplicationError: [err.Error]
          }
        }
        const response = {
          status,
          data,
        }
        dispatch(savePostEventAdvancersError(response));
      });
  }
}


export function fetchingAdvancers() {
  return {
    type: types.PostEvent.FETCHING_ADVANCERS,
  }
}

export function fetchAdvancers(seasonId, searchBy, searchValue) {
  return (dispatch, getState) => {
    const url = `${postEventURL}/searchadvancers/${seasonId}/${searchBy}/${searchValue}`
    const userToken = getState().oidc.user.access_token
    getRequest(url, 'json', userToken).then(resp => {
      dispatch(fetchAdvancersSuccess(resp.data))
    })
  }
}

export function fetchAdvancersSuccess(advancers) {
  return {
    type: types.PostEvent.FETCH_ADVANCERS,
    payload: advancers
  }
}



export function fetchAlternateParentEmailSuccess(alternateEmail) {
  return {
    type: types.PostEvent.FETCH_ALTERNATE_PARENT_EMAIL,
    payload: alternateEmail
  }
}
export function fetchAlternateParentEmail(alternateId) {
  return (dispatch, getState) => {
    const userToken = getState().oidc.user.access_token
    const url = `${postEventURL}/${alternateId}/searchalternateparentemail`
    getRequest(url, 'json', userToken).then(resp => {
      dispatch(fetchAlternateParentEmailSuccess(resp))
    })
  }
}

export function fetchAdvancerParentEmailSuccess(advancerEmail) {
  return {
    type: types.PostEvent.FETCH_ADVANCER_PARENT_EMAIL,
    payload: advancerEmail
  }
}
export function fetchAdvancerParentEmail(advancerId) {
  return (dispatch, getState) => {
    const userToken = getState().oidc.user.access_token
    const url = `${postEventURL}/${advancerId}/searchadvancerparentemail`
    getRequest(url, 'json', userToken).then(resp => {
      dispatch(fetchAdvancerParentEmailSuccess(resp))
    })
  }
}

export function triggeringAdvancerProcess() {
  return {
    type: types.PostEvent.TRIGGERING_ADVANCER_PROCESS,
  }
}

export function triggerAdvancerProcess(seasonId) {
  return (dispatch, getState) => {
    const url = `${postEventURL}/triggeradvancerprocess/${seasonId}/`
    const userToken = getState().oidc.user.access_token
    postRequest(url, null, userToken).then(resp => {
      dispatch(triggerAdvancerProcessSuccess(resp.data))
    })
  }
}

export function triggerAdvancerProcessSuccess(advancers) {
  return {
    type: types.PostEvent.TRIGGER_ADVANCER_PROCESS,
    payload: advancers
  }
}


// WEBPACK FOOTER //
// ./src/redux/actions/action_postEvent.js